import * as React from 'react';
import Button from '@app/react-common/components/button/Button';

interface BulkEditModalLayoutProps {
  title: string;
  onClose: () => void;
  onBack?: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const BulkEditModalLayout = ({ title, onClose, onBack, children, footer }: BulkEditModalLayoutProps) => {
  return (
    <>
      <div className="bulk-edit-modal__header">
        <div className="bulk-edit-modal__header__left">
          {onBack && <Button icon="back" variant="ghost" size="small" onClick={onBack} />}
          <h2>{title}</h2>
        </div>
        <Button icon="close" variant="ghost" size="small" onClick={onClose} />
      </div>
      <div className="bulk-edit-modal__content">{children}</div>
      <div className="bulk-edit-modal__footer">
        {footer || <Button text="Back" onClick={onBack || onClose} size="medium" variant="secondary" />}
      </div>
    </>
  );
};
